const Navbar = () => {
  return (
    <div className="flex items-center justify-center w-full bg-blue-500 shadow-lg my_navbar">
      <h1 className="text-3xl text-white text-opacity-80">Railway Booking Portal</h1>
    </div>
  );
};

export default Navbar;
